import styled from 'styled-components'
import Colors from '../../constants/colors'

export const DescriptionDiv = styled.div`
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.88;
  position: relative;
  z-index: 2;
  .bottomInfo {
    margin-left: 60px;
    margin-top: 30px;
    @media (max-width: 600px) {
      margin-top: 0;
      margin-left: 20px;
    }
  }
  .infoWrap {
    margin-left: 124px;
    width: 50%;
    margin-right: 20px;
    @media (max-width: 1100px) {
      margin-left: 60px;
    }
    @media (max-width: 1000px) {
      width: 100%;
    }
    @media (max-width: 768px) {
      margin-left: 50px;
    }
    @media (max-width: 600px) {
      margin-left: 20px;
    }
  }
  .partnerDiv {
    display: flex;
    align-items: center;
    margin-top: 50px;
    @media (max-width: 600px) {
      margin-top: 20px;
      margin-bottom: 30px;
    }
    .partnerLogo {
      width: 70px;
      height: 70px;
      cursor: pointer;
      object-fit: contain;
      box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
      margin-right: 25px;
      border-radius: 6px;
      transition-duration: 0.2s;
      :hover {
        transform: scale(1.1);
      }      
    }
    .withSupport {
      font-size: 16px;
      margin: 0;
    }
    .partnerSite {
      color: #933ec5;
      font-size: 16px;
    }
  }
  .descriptionHeader {
    margin-bottom: 20px;
    font-family: StolzlMedium, serif;
    font-size: 50px;
    font-weight: 500;
    line-height: 1.2;
    text-transform: uppercase;
    @media (max-width: 768px) {
      width: 100%;
      letter-spacing: 2px;
    }
    @media (max-width: 600px) {
      width: 100%;
      font-size: 20px;
      line-height: 1.5;
      letter-spacing: 1px;
    }
  }
  .descriptionSubHeader {
    text-transform: uppercase;
    margin-top: 30px;
    margin-bottom: 20px;
    @media (max-width: 600px) {
      margin-top: 20px;
      font-size: 14px;
      line-height: 1.5;
      letter-spacing: 1px;
    }
  }
  .socials {
    margin-bottom: 18px;
    @media (max-width: 768px) {
      margin-right: 48px;
      margin-left: auto;
    }
  }
  .descriptionDiv {
    color: #080707;
    margin: 30px 0 30px 0;
    display: block;
    @media (max-width: 600px) {
      margin: 15px 0 20px;
      max-width: calc(100vw - 40px);
      font-size: 14px;
      line-height: 1.57;
      letter-spacing: normal;
      overflow-wrap: break-word;
    }
  }
  
  .linksDiv {
    margin-bottom: 28px;
    @media (max-width: 600px) {
      width: 100%;
    }
  }

  .tags {
    @media (max-width: 600px) {
      margin-bottom: 20px;
      .tag {
        :not(:last-child) {
          margin-right: 18px;
        } 
      }
      .tagsHeader {
        font-size: 14px;
        font-weight: 500;
        line-height: 1.57;
        letter-spacing: normal;
        display: flex;
        align-items: center;
        margin-right: 14px;
        margin-top: 7px;
        &::after {
          content: ":";
        }
      }
    }
  }
  .descriptionLink {
    color: ${Colors.primary};
    text-decoration: underline;
    display: block;
    margin: 10px 0;
  }
`
